import React, {useEffect, useState} from 'react'
import RenderFields from "../../../common/ui/render-fields";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import _ from "lodash";
import {PINTEREST_BOARD_INPUT_FIELDS} from "../../constants/pinterest-board.constant";
import {PINTEREST_ACCOUNT_FILTER_FIELDS} from "../../constants/pinterest-account.constant";

const emptyFilterCriteria: any = {};
let allFilterFields = _.groupBy(PINTEREST_ACCOUNT_FILTER_FIELDS, 'group')['filter'];

const SelectPinterestAccount = ({selectedPinterestAccount, setSelectedPinterestAccount, pinterestAccountsList}) => {
    const [filterFields, setFilterFields] = useState([]);
    const [filterCriteria, setFilterCriteria] = useState(emptyFilterCriteria);

    useEffect(() => {
        prepareFilterOptions();
    }, [pinterestAccountsList]);

    const prepareFilterOptions = () => {
        const options = _.map(pinterestAccountsList, (pinterestAccount) => {
            const account = pinterestAccount?.account;
            return {label: account?.business_name, key: account?.id};
        });

        _.forEach(allFilterFields, (field) => {
            if (field?.attribute === 'accountId') {
                field.options = options;
            }
        });

        setFilterFields(allFilterFields);

        let existingFilterCriteria = {...filterCriteria};
        existingFilterCriteria.accountId = selectedPinterestAccount?.account?.id;
        setFilterCriteria(existingFilterCriteria);
        setSelectedPinterestAccount(pinterestAccountsList[0]);
    }

    const handleFilterChanges = (event) => {
        let existingFilterCriteria = {...filterCriteria};
        existingFilterCriteria = handleFieldValueChanges(event, existingFilterCriteria);
        setFilterCriteria(existingFilterCriteria);

        const selectedAccount = _.find(pinterestAccountsList, {account: {id: existingFilterCriteria.accountId}});
        setSelectedPinterestAccount(selectedAccount);
        console.log('selectedAccount', selectedAccount);
    }

    const clearFilterCriteria = () => {
        setFilterCriteria(emptyFilterCriteria);
    }

    return (
        <>
            <div className="flex flex-wrap justify-start w-full">
                <RenderFields
                    parentForm={filterCriteria}
                    handleDetailChanges={handleFilterChanges}
                    fieldList={filterFields}
                    enableEdit={true}
                    noFieldLabel={true}
                    fieldClassName={`w-1/${(filterFields?.length) || (allFilterFields.length)}`}/>
            </div>
        </>
    )
}

export default SelectPinterestAccount
